import {HandleSubmit} from '../../func/HandleSubmit';
import React, { Component } from 'react';
async function EditFunc(kala_code) {
    console.log("url: ", kala_code);
    const SendParameters = {
        object: "kala",
        detail: {
            kala_code: kala_code,
        }
    };
    alert("dalalalaa");
}
class ShowEditForm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            //kala_code: this.props.index.kala_code,
            //kala_name: this.props.index.kala_name,
            SendParameters: {
                object: "kala",
                detail: {
                    kala_id: this.props.index.kala_id,
                    kala_code: this.props.index.kala_code,
                    kala_name: this.props.index.kala_name,
                }
            }
        };
        this.Refresh = this.props.refresh.bind(this);
        this.CancelFunc = this.props.cancelfunc.bind(this);
    }
    SetParameterValue(name, value) {
        this.state.SendParameters.detail = { ...this.state.SendParameters.detail, [name]: value };
        this.setState({
            SendParameters: this.state.SendParameters,
        });
    }
    async SendEditFunc() {
        var response_info = await HandleSubmit('kala/edit', this.state.SendParameters);
        if (response_info.status.trim() === "OK") {
            alert(" ویرایش");
            this.Refresh();

        }
        else {
            alert("مشکل در ویرایش");
        }
    }
    render() {
        //console.log(this.state.SendParameters.detail);
        if (this.state.Loading) { return "Loading..." }
        return (
            <React.Fragment>
                <tr>
                    <td colspan="1">
                    </td>
                    <td colspan="1">
                        کد کالا
                        <input type="text"
                            className="form-control"
                            value={this.state.SendParameters.detail.kala_code}
                            onChange={(e) => this.SetParameterValue('kala_code', e.target.value)}
                        />
                    </td>
                    <td colSpan="1">
                        نام کالا
                                  <input type="text"
                            className="form-control"
                            value={this.state.SendParameters.detail.kala_name}
                            onChange={(e) => this.SetParameterValue('kala_name', e.target.value)}
                        />
                    </td>
                    <td>
                        <button className="btn btn-success" onClick={() => this.SendEditFunc()}> تایید</button>
                    </td>
                    <td>
                        <button className="btn btn-warning" onClick={() => this.CancelFunc()}> لغو</button>
                    </td>
                </tr>
            </React.Fragment>
        );

    }
}

let ShowEditForm1 = (props) => (
    <React.Fragment>
        <td>
        </td>
        <td>
            <input type="text"
                className="form-control"
                value={props.index.kala_code}
            // onChange={(e) => funcSetParameterValue('name', e.target.value)}
            />
        </td>
        <td>
            <input type="text"
                className="form-control"
                value={props.index.kala_name}
            // onChange={(e) => funcSetParameterValue('name', e.target.value)}
            />
        </td>

    </React.Fragment>
);


export { EditFunc, ShowEditForm };




// WEBPACK FOOTER //
// ./src/pages/Kala/EditKala.js